const $accordion = $('.accordion--steps');
const activeClass = 'is-open';

$accordion.on('click', '.accordion__head', function(event) {
  event.preventDefault();
  const isDesktop = $(window).width() > 1023;

  if (isDesktop) {
    return
  }

  const $this = $(event.currentTarget);

  $this
    .siblings().slideToggle()
    .parent('.accordion__section').toggleClass(activeClass)
    .siblings().removeClass(activeClass)
    .find('.accordion__body').slideUp()
});